import CasFormInput from '@cas/components/inputs/cas-form-input/CasFormInput';
import { useTranslation } from 'react-i18next';
import { Control } from 'react-hook-form';
import { UiSettingsModel } from '@casops/store/apis/settingsApi';

interface SiteDetailsControlsProps {
  control: Control<UiSettingsModel, unknown, UiSettingsModel>;
}

export function SiteDetailsProviderControls({ control }: SiteDetailsControlsProps) {
  const { t } = useTranslation();

  return (
    <CasFormInput control={control} name="siteName" label={t('Fields.SiteName')} type="text" />
  );
}

export default SiteDetailsProviderControls;
